import { AbilityBuilder, Ability } from '@casl/ability'

import ROLE from '../enums/roles'
import ability from '../services/ability'

import store from '@/store'

export function useSetUpdateAbility() {
  const setUpdateAbility = () => {
    // Normalize role to lowercase for consistent comparisons
    const role = store.state.globalComponents.role?.toLowerCase() || ''
    console.log('[useSetUpdateAbility] Role from store:', store.state.globalComponents.role, 'Normalized:', role)
    const { can, rules } = new AbilityBuilder(Ability)

    if (role === ROLE.ADVISOR) {
      can('advisor', 'all')
      can('advisor', 'update')
      can('advisor', 'read')
    }

    if (role === ROLE.CLIENT) {
      can('client', 'all')
      can('client', 'update')
      can('client', 'read')
    }

    if (role === ROLE.LEAD) {
      can('lead', 'all')
      can('lead', 'update')
      can('lead', 'read')
    }

    if (role === ROLE.ADMIN) {
      can('admin', 'all')
      can('admin', 'update')
      can('admin', 'read')
    }

    if (role === ROLE.CEO) {
      can('ceo', 'all')
      can('ceo', 'update')
      can('ceo', 'read')
    }

    if (role === ROLE.ASSISTANT) {
      can('assistant', 'all')
      can('assistant', 'update')
      can('assistant', 'read')
    }

    if (role === ROLE.SUPPORT) {
      can('support', 'all')
      can('support', 'update')
      can('support', 'read')
    }

    if (role === ROLE.OTHER) {
      can('other', 'all')
      can('other', 'update')
      can('other', 'read')
    }

    // Fallback for any unknown roles - treat them as 'other'
    const knownRoles = [
      ROLE.ADVISOR,
      ROLE.CLIENT,
      ROLE.LEAD,
      ROLE.ADMIN,
      ROLE.CEO,
      ROLE.ASSISTANT,
      ROLE.SUPPORT,
      ROLE.OTHER,
    ]
    if (!knownRoles.includes(role)) {
      console.warn(`[useSetUpdateAbility] Unknown role '${role}'. Setting 'other' abilities.`)
      can('other', 'all')
      can('other', 'update')
      can('other', 'read')
    }

    ability.update(rules)
  }
  return { setUpdateAbility }
}
